import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';

// Load nsemble Web Components
const loadNsembleComponents = () => {
  const baseline = document.createElement('script');
  baseline.src = 'https://web-components.ddcplatform.dealer.com/nsemble-baseline.js';
  document.head.appendChild(baseline);

  const polyfills = document.createElement('script');
  polyfills.src = 'https://web-components.ddcplatform.dealer.com/nsemble-polyfills.js';
  document.head.appendChild(polyfills);
};

loadNsembleComponents();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
